import { useAuth } from '../auth/AuthContext';
import { Navigate } from 'react-router';

export const ProtectedRoute = ({ children }) => {
  const { authenticated } = useAuth();

  if (!authenticated) return <Navigate to="/" replace />;

  return children;
};
